// index.tsx
// MOB-5 — Polyfills legacy (core-js + regenerator-runtime) chargés en premier
import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { showUpdateBanner } from './swUpdate';

// MOB-5 — Détection Internet Explorer (navigateur non supporté)
// IE est détecté via la présence de `documentMode` sur document (propriété propriétaire MS)
const isIE = typeof document !== 'undefined' && !!(document as any).documentMode;

if (isIE) {
  document.body.innerHTML =
    '<div style="font-family: Arial, sans-serif; max-width: 640px; margin: 80px auto; padding: 32px; text-align: center; border: 1px solid #ddd; border-radius: 8px;">' +
    '<h1 style="color: #b91c1c; font-size: 22px; margin-bottom: 16px;">Navigateur non supporté</h1>' +
    '<p style="color: #374151; font-size: 16px; line-height: 1.5;">Veuillez utiliser un navigateur moderne&nbsp;: ' +
    '<strong>Chrome</strong>, <strong>Firefox</strong>, <strong>Edge</strong> ou <strong>Safari</strong> récent.</p>' +
    '</div>';
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();

  // MOB-3 — PWA : enregistre le service worker (no-op en dev, actif en prod)
  // À chaque nouveau build front, une bannière « nouvelle version disponible »
  // propose à l'utilisateur de recharger (évite de rester bloqué sur une version cachée).
  // En dev : tue tout SW résiduel d'un ancien build de prod (sinon bundle périmé servi en cache).
  serviceWorkerRegistration.unregister();
}